import {
  type Account,
  type InventoryResource,
  type Snapshot,
  Provider,
} from '@repo/api-gw-sdk';

import { AzureSqlDbConfiguration } from './steps/azureSqlDbConfiguration';
import { SelectTargetAccountStep } from './steps/selectTargetAccount';

import type { Step } from '../wizard/Step';
import { Wizard } from '../wizard/Wizard';

export interface RestoreAzureSqlDBState {
  resourceId: string;
  snapshot: Snapshot;
  supportedCloudProviders: Provider[];
  restoreAccount?: Account;
  resourceGroup?: string;
  location?: string;
  serverName?: string;
  adminLogin?: string;
  SKU?: string;
  keepOriginalTags: boolean;
  initialTags: Record<string, string>;
  tags: Record<string, string>;
}

const restoreAzureSqlDBFlow: Step<RestoreAzureSqlDBState> = {
  name: 'SelectTargetAccountStep',
  Component: SelectTargetAccountStep,
  next: [
    {
      name: 'AzureSqlDbConfiguration',
      Component: AzureSqlDbConfiguration,
    },
  ],
};

export const RestoreAzureSqlDBWizard = ({
  resource,
  snapshot,
  onClose,
  onBack,
}: {
  resource: InventoryResource;
  snapshot: Snapshot;
  onClose: () => void;
  onBack: () => void;
}) => {
  return (
    <Wizard<RestoreAzureSqlDBState>
      onAbort={(origin) => (origin === 'back' ? onBack() : onClose())}
      onFinish={async () => true}
      flow={[restoreAzureSqlDBFlow]}
      initialState={{
        snapshot,
        resourceId: resource.id,
        supportedCloudProviders: [Provider.Azure],
        serverName: resource.resourceName.split('/')[0] ?? '',
        adminLogin: snapshot.resource?.properties?.azureMssql?.adminLogin ?? '',
        SKU: snapshot.resource?.properties?.azureMssql?.sku ?? '',
        keepOriginalTags: true,
        initialTags: snapshot.resource?.tags || {},
        tags: snapshot.resource?.tags || {},
        location: resource.region,
      }}
      title={'Restore Sql Database'}
      stepperLabels={['Restore Account', 'Configuration']}
    />
  );
};
